import React, { Component } from 'react';
/* eslint-disable */
import axios from 'axios';
import { MY_API_URL } from './QueryMe';

var dateFormat = require('dateformat');
import { Col, Badge } from 'reactstrap';

const apiurl = MY_API_URL;

const initialstate = {
	allmsgs: [],
	token: localStorage.token,
};

class Ticketmsgs extends Component {
	constructor(props) {
		super(props);
	}
	state = { ...initialstate };
	componentDidMount() {
		this.setState(
			{
				ticketid: this.props.ticketid,
			},
			() => {
				this.handleGetTMsgs(localStorage.token);
			},
		);
	}

	handleGetTMsgs = (token) => {
		const headers = {
			'Content-Type': 'application/json',
			Authorization: localStorage.token,
		};
		var postData = {
			token: token,
			tid: this.state.ticketid,
		};
		const getuurl = apiurl + 'getTmsgs';
		axios
			.post(getuurl, postData, {
				headers: headers,
			})
			.then((response) => {
				if (response.data.error) {
				} else {
					this.setState({
						allmsgs: [...response.data.data],
					});
				}
			})
			.catch((error) => {});
	};

	render() {
		return (
			<Col md={12}>
				{this.state.allmsgs &&
					this.state.allmsgs.map((ticket, index) => {
						return (
							<div className="profile__activity" key={index}>
								<p className="profile__activity-name">
									{ticket.lable}
									<span className="profile__activity-date">
										Date: {dateFormat(ticket.posted, 'd-m-yyyy')}
									</span>
								</p>
								<p>{ticket.description}</p>
							</div>
						);
					})}
			</Col>
		);
	}
}

export default Ticketmsgs;
